import _get from 'lodash/get';
import _unset from 'lodash/unset';
import { checkPropertyTypes } from '@/lib/serializerUtils';
import { stripUIDsWhenPlainJSON, post } from '@/lib/utils';
import { FatalErrorException } from '@/lib/exceptions';
import store from '@/store';

const serializeSave = async ({ record, className, meta }) => {
  const keys = Object.keys(record);
  // Standard for loop to lower the amount of overhead
  for (let i = 0; i < keys.length; i += 1) {
    const clientSerialize = _get(meta, `properties[${keys[i]}].property_meta.clientserialize`, true);
    if (!clientSerialize) _unset(record, keys[i]);
  }
  let serializedRecord;
  let serializer = null;
  try {
    // eslint-disable-next-line global-require, import/no-dynamic-require
    serializer = require(`./${className}.js`).default;
  } catch (e) {
    // Most likely the serializer has not been found, normally harmless, but a missing or
    // invalid classname can cause serious issues like setting itemprice on an order to 0
    let message;
    if (!className || typeof className !== 'string') {
      message = `[serializeSave] ERROR: Missing or invalid classname. (value: ${className})`;
    } else if (!store.getters['meta/meta'][className]) {
      message = `[serializeSave] ERROR: Classname missing from schema. (value: ${className})`;
    }

    if (message) {
      message += `\n[serializeSave] Msg: ${e} \
                  \n[serializeSave] className: ${className} \
                  \n[serializeSave] Username: ${store.getters['auth/username']} (${store.getters['auth/useralias']})`;
      if (record && record.mainorderid) message += `\n[serializeSave] Order ID: ${record.mainorderid}`;

      // We're rolling our own fatal error for this one, so raise_fatal: false
      post('/tg/system/log_debug', { message, raise_fatal: false });
      throw new FatalErrorException(e);
    }
  }

  if (serializer) {
    try {
      serializedRecord = serializer(record);
      stripUIDsWhenPlainJSON(serializedRecord);
    } catch (e) {
      post('/tg/system/log_debug', { message: `[serializeSave] ERROR: ${e}`, raise_fatal: false });
      throw new FatalErrorException(e);
    }
  }
  return checkPropertyTypes(serializedRecord || record, className);
};

export {
  serializeSave,
};
